<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import { useSentryFeedback } from "@/composables/shared/useSentryFeedback";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    useDefaultPlace?: boolean;
    excludeRoute?: string;
    color?: string;
    variant?: "text" | "elevated" | "flat" | "outlined" | "plain" | "tonal" | undefined;
    size?: string;
  }>(),
  {
    useDefaultPlace: true,
    excludeRoute: undefined,
    color: "#6c5fc7",
    variant: undefined,
    size: undefined,
  }
);

const route = useRoute();
const { isDisabled, openFeedback } = useSentryFeedback();

const isRouteExcluded = computed(() => {
  return !!props.excludeRoute && route.path.includes(props.excludeRoute);
});
</script>

<template>
  <v-list-item
    v-if="!isRouteExcluded && !useDefaultPlace && !variant"
    v-bind="$attrs"
    class="tw:cursor-pointer"
    :disabled="isDisabled"
    @click="openFeedback"
  >
    <template #prepend>
      <v-icon
        icon="mdi-bug"
        size="18"
      />
    </template>

    <v-list-item-title>
      {{ t("generic.sentry.feedback") }}
    </v-list-item-title>
  </v-list-item>
  <v-btn
    v-else-if="!isRouteExcluded && !useDefaultPlace && variant"
    v-bind="$attrs"
    :prepend-icon="'mdi-bug'"
    :color="color"
    :variant="variant"
    :size="size"
    class="tw:transition-transform hover:tw:scale-105"
    :class="variant === 'text' ? 'tw:!text-xxs' : ''"
    rounded="xl"
    :disabled="isDisabled"
    @click="openFeedback"
  >
    {{ t("generic.sentry.feedback") }}
  </v-btn>
  <v-btn
    v-else-if="!isRouteExcluded"
    v-bind="$attrs"
    :prepend-icon="'mdi-bug'"
    :color="color"
    variant="flat"
    class="tw:transition-transform hover:tw:scale-105 tw:!text-xxs tw:fixed tw:bottom-4 tw:right-4"
    rounded="xl"
    :disabled="isDisabled"
    @click="openFeedback"
  >
    {{ t("generic.sentry.feedback") }}
  </v-btn>
</template>
